import { Provider } from '@angular/core'
import { FmxErrorsService } from './errors.service'
import { ErrorsVisibility } from './errors-visibility'

export interface FmxErrorsModuleConfig {
	errorsVisibility?: ErrorsVisibility
}

export function provideFmxErrors(): Array<Provider> {
	return [FmxErrorsService]
}
